module.exports = __webpack_public_path__ + "images/_/programs/epsHybridPrimaries/images/characters/ian_pointing_left-4596053eb82e04f727bdd744c3de0325.png";


//////////////////
// WEBPACK FOOTER
// ./programs/epsHybridPrimaries/images/characters/ian_pointing_left.png
// module id = 2297
// module chunks = 2